import { convertToDateTime } from '../helper/dateTime-helper';

/**
 * Model to hold a scheduled item (e.g. session start/end)
 */
export class ScheduleItem {
    public id: string = null;
    public eventId: string = null;
    public startDateTime: Date = null;
    public endDateTime: Date = null;
    public eventTimeZone: string = null;

    private _description: string;
    set description(description: string) {
        this._description = description && description.trim();
    }

    get description(): string {
        return this._description;
    }

    /**
     * Constructor
     */
    constructor(eventId: string) {
        this.eventId = eventId;
    }

    public clone(): ScheduleItem {
        const clone: ScheduleItem = new ScheduleItem(this.eventId);
        clone.id = this.id;
        clone.eventId = this.eventId;
        clone.startDateTime = this.startDateTime && new Date(this.startDateTime.getTime());
        clone.endDateTime = this.endDateTime && new Date(this.endDateTime.getTime());
        clone.eventTimeZone = this.eventTimeZone;
        return clone;
    }

    public isEmpty(): boolean {
        return (!this.startDateTime && !this.endDateTime && !this.description);
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'scheduleItem';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.description = this.description;
        json.data.attributes.startDateTimeUtc = null;
        json.data.attributes.endDateTimeUtc = null;

        if (this.startDateTime) {
            json.data.attributes.startDateTimeUtc = this.startDateTime.toISOString();
        }

        if (this.endDateTime) {
            json.data.attributes.endDateTimeUtc = this.endDateTime.toISOString();
        }

        return JSON.stringify(json);
    }

    /**
     * Deserialize to json api format
     */
    public deserialize(json: any): ScheduleItem {
        const data: any = json.data || json;
        const attrs: any = data.attributes || {};

        this.id = data.id;
        this.description = attrs.description;
        this.eventTimeZone = attrs.eventTimeZone;

        if (attrs.startDateTime) {
            this.startDateTime = convertToDateTime(attrs.startDateTime);
        }
        if (attrs.endDateTime) {
            this.endDateTime = convertToDateTime(attrs.endDateTime);
        }

        return this;
    }
}
